import { NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { Salesperson } from '@galaxy/types';
import { PipelineTableService } from './pipeline-table.service';
import { SearchbarModule } from '../searchbar/searchbar.module';
import {
  ALL_SALESPEOPLE_TOKEN,
  DEFAULT_CURRENCY_TOKEN,
  PipelineTableServiceConfig,
  PIPELINE_TABLE_SERVICE_CONFIG_TOKEN,
  OPPORTUNITY_DETAILS_URL_TOKEN,
  ACCOUNT_DETAILS_URL_TOKEN,
} from './tokens';
import { MARKET_ID_TOKEN, PARTNER_ID_TOKEN } from '../tokens';
import { OpportunityUrlFunction } from '../../sales-opportunities/opportunity';
import { PipelineFiltersServiceModule } from '../../filters/filters-service/pipeline-filters-service.module';
import { PIPELINE_SERVICE_INJECTION_TOKEN } from '../pipeline/pipeline-service.interface';

@NgModule({
  imports: [SearchbarModule, PipelineFiltersServiceModule],
  providers: [
    PipelineTableService,
    {
      provide: PIPELINE_SERVICE_INJECTION_TOKEN,
      useExisting: PipelineTableService,
    },
    { provide: PARTNER_ID_TOKEN, deps: [PIPELINE_TABLE_SERVICE_CONFIG_TOKEN], useFactory: partnerIdFactory },
    { provide: MARKET_ID_TOKEN, deps: [PIPELINE_TABLE_SERVICE_CONFIG_TOKEN], useFactory: marketIdFactory },
    { provide: ALL_SALESPEOPLE_TOKEN, deps: [PIPELINE_TABLE_SERVICE_CONFIG_TOKEN], useFactory: allSalespeopleFactory },
    {
      provide: DEFAULT_CURRENCY_TOKEN,
      deps: [PIPELINE_TABLE_SERVICE_CONFIG_TOKEN],
      useFactory: defaultCurrencyFactory,
    },
    {
      provide: OPPORTUNITY_DETAILS_URL_TOKEN,
      deps: [PIPELINE_TABLE_SERVICE_CONFIG_TOKEN],
      useFactory: opportunityDetailsUrlGeneratorFactory,
    },
    {
      provide: ACCOUNT_DETAILS_URL_TOKEN,
      deps: [PIPELINE_TABLE_SERVICE_CONFIG_TOKEN],
      useFactory: accountDetailsUrlGeneratorFactory,
    },
  ],
})
export class PipelineTableServiceModule {}

function partnerIdFactory(config: PipelineTableServiceConfig): Observable<string> {
  return config.partnerId$;
}

function marketIdFactory(config: PipelineTableServiceConfig): Observable<string> {
  return config.marketId$;
}

function allSalespeopleFactory(config: PipelineTableServiceConfig): Observable<Salesperson[]> {
  return config.allSalespeople$;
}

function defaultCurrencyFactory(config: PipelineTableServiceConfig): Observable<string> {
  return config.defaultCurrency$;
}

function opportunityDetailsUrlGeneratorFactory(config: PipelineTableServiceConfig): OpportunityUrlFunction {
  return config.getOpportunityDetailsUrl;
}

function accountDetailsUrlGeneratorFactory(config: PipelineTableServiceConfig): OpportunityUrlFunction {
  return config.getAccountDetailsUrl;
}
